import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import axios from 'axios';
import { useMedia } from 'react-use';
import { Columns } from 'ui-base';
import { Button, Icon, Loading, LazyLoadImage } from 'ck-ui';
import { getImgixUrl } from 'ck-utils';
import { getSalePercentage, getPriceString } from 'ck-utils/price';
import layout from 'ck-utils/layout.module.scss';
import styles from './BundleListing.module.scss';

const BundleListing = () => {
  const ITEMS_PER_PAGE = 12;
  const [bundles, setBundles] = useState(null);
  const [numToShow, setNumToShow] = useState(ITEMS_PER_PAGE);
  const isMobile = useMedia('(max-width: 767px)');

  useEffect(() => {
    (async () => {
      const response = await axios.get('/collections/bundles?view=bundles-json');
      const results = await response.data.bundles;
      setBundles(results);
      window.theme.afterpayMarketingModal();
    })();
  }, []);

  return bundles ? (
    <>
      <Columns multiline>
        {bundles.slice(0, numToShow).map((bundle) => {
          const { url, image, title, details: { price, compareAtPrice } } = bundle;
          const showSash = Number(compareAtPrice) > Number(price);
          const discountedPercentage = getSalePercentage(price, compareAtPrice);

          return (
            <Columns.Column key={title} className="product-tile-container" desktop={{ size: 3 }} tablet={{ size: 4 }}>
              <div className="product-tile-image-wrapper">
                <a href={url}>
                  <LazyLoadImage
                    src={getImgixUrl(image)}
                    alt={title}
                  />
                </a>
                {showSash && (
                  <div className="sash-base collection-text-sash">
                    <span className="sash-text">{`Save up to ${discountedPercentage}%`}</span>
                  </div>
                )}
              </div>
              <h5 className={classnames('product-tile-product-title', layout.marginTop)}>
                <a href={url}>{title}</a>
              </h5>
              <div className="product-tile-price-parent">
                <span className="product-price product-price--on-sale">{getPriceString(price)}</span>
                {showSash && <span className="product-compare-price text--strike">{getPriceString(compareAtPrice)}</span>}
              </div>
              <div className="has-afterpay has-text-centered">
                <a className="js-afterpay-popup" href="#">
                  Or <span className="js-afterpay-price pdp-afterpay">{getPriceString(Number(price) / 4)}</span>
                  <span className="pdp-afterpay-pmt"> (over 4 payments) </span>
                  <img
                    className="afterpay-logo"
                    alt="afterpay"
                    src="//cdn.shopify.com/s/files/1/1023/3455/t/3/assets/afterpay_logo.svg?v=16034147659259765906"
                  />
                </a>
              </div>
              {showSash && (
                <div className={classnames('has-text-centered', layout.marginTop)}>
                  <span className="has-background-danger has-text-white sash-text">{`Save up to ${discountedPercentage}%`}</span>
                </div>
              )}
            </Columns.Column>
          );
        })}
      </Columns>
      {bundles.length > numToShow && (
        <div className={classnames(layout.marginTopLarge, styles.loadMoreContainer)}>
          <Button
            secondary
            size={isMobile ? null : 'large'}
            fullwidth="mobile"
            onClick={() => setNumToShow(numToShow + ITEMS_PER_PAGE)}
          >
            LOAD MORE
          </Button>
          <Icon
            className={styles.scrollTop}
            size={isMobile ? 'large' : 'exLarge'}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            name="scroll-top"
          />
        </div>
      )}
    </>
  ) : (
    <Loading isLoading />
  );
};

export { BundleListing };
